<div class="last-records">
  <div *ngIf="!tabs || tabs.length === 0" class="last-records-title">{{ title }}</div>

  <ng-container *ngIf="tabs && tabs.length > 0">
    <div class="tabs">
      <button *ngFor="let tab of tabs" class="tab-btn" [class.active]="activeTab === tab.value"
        (click)="selectTab(tab.value)">
        {{ tab.label }}
      </button>
    </div>
  </ng-container>

  <div class="scrollbar last-questionnaire-scrollbar" id="style-1">
    <div class="last-records-content">

      <div *ngIf="isNutrition">
        <ng-content>
        </ng-content>
      </div>
      <!-- <ng-content> -->

      <div *ngIf="!isNutrition" style="padding: 10px;">Funcionalidade de Últimos Registros em desenvolvimento.</div>

      <!-- </ng-content> -->
    </div>
  </div>
</div>